export const WEB_DEFAULT = 'WebDefault'
export const WEB_2K = 'Web2k'
export const WEB_4K = 'Web4k'
export const MOBILE_DEFAULT = 'MobileDefault'
export const MOBILE_SMALL = 'MobileSmall'
export const TABLET = 'Tablet'
